import { v4 as uuidv4 } from "uuid";
import { parseDatetimeLocalToUTC } from "../../../helpers/commonHelper";
import { IThuPhiNhapHocTab } from "../../../model/request/thu-phi-nhap-hoc/IThuPhiNhapHocTab";
import { IThuPhiNhapHocActionTypes } from "../../action-types/thu-phi-nhap-hoc/IThuPhiNhapHocActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IThuPhiNhapHocReducer } from "../../reducer-model/thu-phi-nhap-hoc/IThuPhiNhapHocReducer";
import { IMucThuNhapHocSinhVienViewModel } from "../../../model/respone/chung-tu-nhap-hoc/IMucThuNhapHocSinhVienViewModel";
const iniTab: IThuPhiNhapHocTab = {
  id: uuidv4(),
  title: "Untitled",
  mucThuNhapHocs: [],
  mucThuNhapHocSelectedIds: [],
  step: 0,
  namNhapHoc: 0,
  hinhThucNops: [],
  status: eReducerStatusBase.is_not_initialization,
  thongTinBienLai: {
    bienLaiId: 0,
    bienLaiPhieuThu: "",
    bienLaiTempPhieuThu: "",
    loaiBienLai: "thu",
    chiTuBienLaiId: 0,
  },
};
const iniState: IThuPhiNhapHocReducer = {
  selectedId: iniTab.id,
  tabs: [iniTab],
};
export const thuPhiNhapHocReducer = (
  state: IThuPhiNhapHocReducer = iniState,
  action: IThuPhiNhapHocActionTypes,
): IThuPhiNhapHocReducer => {
  switch (action.type) {
    case "THU_PHI_NHAP_HOC_ADD_NEW_TAB":
      let exist = state.tabs.find(
        (g) =>
          g.sinhVien?.id_sv === action.payload?.id_sv &&
          g.thongTinBienLai.bienLaiId <= 0,
      );
      const id = exist?.id ?? uuidv4();
      return {
        ...state,
        selectedId: id,
        tabs: exist
          ? [...state.tabs]
          : [
              {
                ...iniTab,
                title: action.payload?.ho_ten ?? "Untitled",
                id: id,
                sinhVien: action.payload,
              },
              ...state.tabs,
            ],
      };
    case "THU_PHI_NHAP_HOC_REMOVE_TAB":
      return {
        ...state,
        tabs: state.tabs.filter((t) => t.id !== action.payload),
      };
    case "THU_PHI_NHAP_HOC_UPDATE_TAB_DATA":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return action.payload;
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CHANGEG_SELECTED_TAB":
      return {
        ...state,
        selectedId: action.payload,
      };
    case "THU_PHI_NHAP_HOC_LOAD_MUC_THU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              namNhapHoc: action.payload.nam_nhap_hoc,
              status: eReducerStatusBase.is_loading,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_LOAD_MUC_THU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuNhapHocs: action.payload.data,
              mucThuNhapHocSelectedIds: [],
              hinhThucNops: [],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_LOAD_MUC_THU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuNhapHocs: [],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CHANGE_MUC_THU_SELECTED_IDs":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            let muc_thu_selected_id_news = action.payload.data.filter(
              (item) => !t.mucThuNhapHocSelectedIds.includes(item),
            );
            return {
              ...t,
              hinhThucNops: [],
              mucThuNhapHocSelectedIds: action.payload.data,
              mucThuNhapHocs: t.mucThuNhapHocs.map((g) => {
                if (action.payload.data.includes(g.id_thu_chi)) {
                  if (muc_thu_selected_id_news?.includes(g.id_thu_chi)) {
                    return {
                      ...g,
                      so_tien_thuc_nop: Math.abs(g.so_tien_con_lai),
                    };
                  }
                  return g;
                }
                return {
                  ...g,
                  so_tien_thuc_nop: 0,
                };
              }),
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CHANGE_STEP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              step: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CHANGE_HINHTHUCNOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CREATE_BIENLAITHU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CREATE_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              //status: eReducerStatusBase.is_completed,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: action.payload.data,
              },
              step: 2,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CREATE_BIENLAITHU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              bienLaiId: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_LOAD_EDIT_BIENLAI_SUCCESS": {
      const detail = action.payload.data;
      const chiTiets = detail?.bienLaiThuChiTiets ?? [];
      const selectedIds = Array.from(
        new Set(chiTiets.map((c: any) => c.id_thu_chi)),
      ) as number[];
      const amountByThuChi: { [key: number]: number } = {};
      chiTiets.forEach((c: any) => {
        amountByThuChi[c.id_thu_chi] =
          (amountByThuChi[c.id_thu_chi] ?? 0) + c.so_tien;
      });
      // Ghi chú theo TỪNG khoản: nạp lại để người dùng SỬA được (trước đây chỉ nạp số
      // tiền → mở sửa là ô ghi chú trống trơn, lưu lại sẽ mất ghi chú cũ).
      // Nhiều dòng chi tiết cùng 1 khoản (hiếm) → lấy ghi chú khác rỗng đầu tiên.
      const ghiChuByThuChi: { [key: number]: string } = {};
      chiTiets.forEach((c: any) => {
        const g = (c.ghi_chu ?? "").trim();
        if (g && !ghiChuByThuChi[c.id_thu_chi])
          ghiChuByThuChi[c.id_thu_chi] = c.ghi_chu;
      });
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              editingBienLaiId: detail.id_bien_lai,
              // Phiếu QR/ngân hàng: khóa khoản + số tiền, chỉ mở ghi chú và thời gian nộp.
              chiSuaGhiChuNgay: detail.chi_sua_ghi_chu_ngay === true,
              editingSoPhieu: `${detail.so_phieu_header ?? ""}${detail.so_phieu ?? ""}`,
              editingSoTien: detail.so_tien,
              step: 0,
              status: eReducerStatusBase.is_completed,
              mucThuNhapHocSelectedIds: selectedIds,
              mucThuNhapHocs: t.mucThuNhapHocs.map((g) => ({
                ...g,
                so_tien_thuc_nop: amountByThuChi[g.id_thu_chi] ?? 0,
                ghi_chu_dong: ghiChuByThuChi[g.id_thu_chi] ?? "",
              })),
              hinhThucNops: (detail.bienLaiThuHinhThucNops ?? []).map(
                (h: any, idx: number) => ({
                  id: idx,
                  so_tien: h.so_tien,
                  acc_bienlaithu_hinhthucnoptien_id:
                    h.acc_bienlaithu_hinhthucnoptien_id,
                  acc_bienlaithu_hinhthucnoptien_name:
                    h.acc_bienlaithu_hinhthucnoptien_name ?? "",
                  ghi_chu: h.ghi_chu ?? "",
                  id_bien_lai: detail.id_bien_lai,
                }),
              ),
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: 0,
                bienLaiTempPhieuThu: "",
                loaiBienLai: detail.thu_chi ? "chi" : "thu",
                // ★ Ép "giờ tường vào UTC" (parseDatetimeLocalToUTC) chứ KHÔNG new Date() thô:
                // chuỗi server không có múi giờ nên new Date() hiểu là giờ địa phương, lúc lưu
                // chỉnh sửa JSON.stringify trả về UTC → ngày thu bị LÙI 7 TIẾNG mỗi lần lưu.
                ngayThu: detail.ngay_thu
                  ? parseDatetimeLocalToUTC(detail.ngay_thu)
                  : t.thongTinBienLai.ngayThu,
                idCoSo: detail.id_co_so ?? t.thongTinBienLai.idCoSo,
              },
            };
          }
          return t;
        }),
      };
    }
    case "THU_PHI_NHAP_HOC_CANCEL_EDIT_BIENLAI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              editingBienLaiId: 0,
              chiSuaGhiChuNgay: false,
              editingSoPhieu: undefined,
              editingSoTien: undefined,
              mucThuNhapHocSelectedIds: [],
              hinhThucNops: [],
              step: 0,
              status: eReducerStatusBase.is_need_reload,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: 0,
                bienLaiTempPhieuThu: "",
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_UPDATE_BIENLAITHU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_UPDATE_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              editingBienLaiId: 0,
              chiSuaGhiChuNgay: false,
              editingSoPhieu: undefined,
              editingSoTien: undefined,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: action.payload.data,
              },
              step: 2,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_UPDATE_BIENLAITHU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CHANGE_SO_TIEN_THUC_NOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuNhapHocSelectedIds: [
                ...t.mucThuNhapHocSelectedIds.filter(
                  (g) => g !== (action.payload.request?.id_thu_chi ?? 0),
                ),
                action.payload.data > 0
                  ? (action.payload.request?.id_thu_chi ?? 0)
                  : 0,
              ],
              mucThuNhapHocs: [
                ...t.mucThuNhapHocs.map(
                  (mtk: IMucThuNhapHocSinhVienViewModel) => {
                    if (mtk.id_thu_chi === action.payload.request.id_thu_chi) {
                      return {
                        ...mtk,
                        so_tien_thuc_nop: action.payload.data,
                      };
                    }
                    return mtk;
                  },
                ),
              ],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CHANGE_GHI_CHU_KHOAN":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              mucThuNhapHocs: t.mucThuNhapHocs.map(
                (mtk: IMucThuNhapHocSinhVienViewModel) =>
                  mtk.id_thu_chi === action.payload.request.id_thu_chi
                    ? { ...mtk, ghi_chu_dong: action.payload.data }
                    : mtk,
              ),
            };
          }
          return t;
        }),
      };

    // Tích "Điều chỉnh giảm định mức" ⇒ đồng thời CHỌN luôn khoản đó, vì bỏ chọn thì
    // khoản không vào phiếu và ô tích thành vô nghĩa.
    case "THU_PHI_NHAP_HOC_CHANGE_DIEU_CHINH_GIAM_DINH_MUC":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            const id = action.payload.request.id_thu_chi ?? 0;
            const daChon = t.mucThuNhapHocSelectedIds.includes(id);
            return {
              ...t,
              mucThuNhapHocSelectedIds: daChon
                ? t.mucThuNhapHocSelectedIds
                : [...t.mucThuNhapHocSelectedIds, id],
              mucThuNhapHocs: t.mucThuNhapHocs.map(
                (mtk: IMucThuNhapHocSinhVienViewModel) =>
                  mtk.id_thu_chi === id
                    ? {
                        ...mtk,
                        is_dieu_chinh_dinh_muc: action.payload.data,
                        // Chọn khoản qua ô này cũng phải điền sẵn "Thực chi" y như tích dòng —
                        // trước đây khoản được chọn nhưng số tiền để 0. Đã chọn rồi thì giữ số
                        // người dùng đang nhập.
                        so_tien_thuc_nop: daChon
                          ? mtk.so_tien_thuc_nop
                          : Math.abs(mtk.so_tien_con_lai),
                      }
                    : mtk,
              ),
            };
          }
          return t;
        }),
      };

    case "THU_PHI_NHAP_HOC_CHANGE_THONGTINBIENLAI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            let obj = {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                ...action.payload.data,
              },
            };
            if ("loaiBienLai" in action.payload.data) {
              obj = {
                ...obj,
                mucThuNhapHocs: [],
                mucThuNhapHocSelectedIds: [],
                hinhThucNops: [],
                step: 0,
                status: eReducerStatusBase.is_need_reload,
                // Đổi thu ⇄ chi thì BỎ luôn phiếu nguồn đã chọn, không thì quay lại "thu"
                // vẫn còn dính nguồn cũ và lưới nạp theo phiếu thay vì theo công nợ.
                thongTinBienLai: {
                  ...obj.thongTinBienLai,
                  chiTuBienLaiId: 0,
                  chiTuBienLaiIds: [],
                },
              };
            }
            return obj;
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_PREVIEW_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiTempPhieuThu: action.payload.data,
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_PREVIEW_BIENLAITHU_CLOSE":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiTempPhieuThu: "",
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_UPDATE_QRCODE":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return {
              ...t,
              qrCode: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_UPDATE_QRCODES":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return {
              ...t,
              qrCodes: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_UPDATE_GENQR_LOADING":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return {
              ...t,
              genQRLoading: action.payload.data,
            };
          }
          return t;
        }),
      };
    default:
      return state;
  }
};
